<template>
  <div class="block_wrap">
<!--    <div class="connected_roles">-->
<!--      <p class="top">-->
<!--        {{ translate("user.role_manage.connected_roles") }}-->
<!--        ({{Object.keys(all_roles_list.connected_roles).length}})-->
<!--      </p>-->
<!--      <TableRole-->
<!--          class="body"-->
<!--          v-if="all_roles_list.connected_roles"-->
<!--          :role_list="all_roles_list.connected_roles"-->
<!--          :permission_list="permission_list"-->
<!--      />-->
<!--    </div>-->
    <div class="available_roles">
      <p class="top">
        {{ translate("client.role_manager.available_roles") }}
      </p>
      <TableRole
          class="body"
          :role_list="role_list"
          :permission_list="permission_list"
          :client_id="client_id"
      />
    </div>
  </div>
</template>
<script>

import TableRole from "./TableRole.vue";

export default {
  name: "ClientRolesForm",
  props:["client_id"],
  components:{
    TableRole
  },
  data () {
    return {
      role_list: [],
      permission_list: []
    }
  },
  created(){
    this.get_all_roles_and_permissions()
  },
  computed:{

  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    get_all_roles_and_permissions(){
      this.$http.v1.getAllRoles((response) => {
        this.role_list = response.data.roles
        this.permission_list = response.data.permissions
      })
    },
  }
}

</script>
<style lang='scss' scoped>
  .block_wrap{
    height: calc(100% - 10px);
  }
  .available_roles{
    height: 100%;
    margin-bottom: 10px;
    .top{
      text-align: start;
      margin-bottom: 0;
      height: 25px;
    }
    .body{
      height: calc(100% - 25px);
    }
  }
</style>
